import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})
export class ConfirmDeleteComponent implements OnInit {
  @Input() routeName: string;
  @Output() onConfirmDelete = new EventEmitter<void>();
  @Output() onCancelDelete = new EventEmitter<void>();

  private formLocked: boolean;

  constructor() { }

  ngOnInit() {
    this.formLocked = false;
  }

  confirmDelete(): void {
    if (!this.formLocked) {
      this.formLocked = true;
      this.onConfirmDelete.emit();
    }
  }

  cancelDelete(): void {
    this.onCancelDelete.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/confirm-delete/confirm-delete.component.ts